import {
  DataAdministrationSidebarAppFeaturesId,
  EvidencePlatformSidebarAppID,
} from '@verantos-dev/core-enums';

export const DATA_ADMIN_BASE_PATH = EvidencePlatformSidebarAppID.dataAdministration;
export const DATA_ADMIN_DATA_INTAKE_PATH = DataAdministrationSidebarAppFeaturesId.dataIntake;
export const DATA_ADMIN_DATA_DELIVERY_PATH = DataAdministrationSidebarAppFeaturesId.datasetDelivery;

export const getDataAdminBasePath = () => `/${DATA_ADMIN_BASE_PATH}`;

export const getDataAdminDataIntakePath = () =>
  `${getDataAdminBasePath()}/${DATA_ADMIN_DATA_INTAKE_PATH}`;

export const getDataAdminDataDeliveryPath = () =>
  `${getDataAdminBasePath()}/${DATA_ADMIN_DATA_DELIVERY_PATH}`;
